var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsTimesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 2C7.40275 2 2.91675 6.486 2.91675 12C2.91675 17.514 7.40275 22 12.9167 22C18.4307 22 22.9167 17.514 22.9167 12C22.9167 6.486 18.4307 2 12.9167 2ZM18.6667 13H11.9167V6H13.9167V11H18.6667V13Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsTimesvg);
export default __webpack_public_path__ + "static/media/bxs-time.svg.b4260c4c6f8bbe34ec8ebb98073d456c.svg";
export { ForwardRef as ReactComponent };